import { ChainId, Network } from "../generated"
import { client } from "../wallet"

let latestChain: string | null
client.chainId$.subscribe((currentChain) => {
  latestChain = currentChain
})

export const getCurrentNetwork = () => Network[latestChain as ChainId]
